import React, { useState, useEffect } from 'react';
import { Select, AutoComplete, Input, Tooltip } from 'antd';

import PropTypes from 'prop-types';
import get from 'lodash/get';

import style from './index.scss';
import { GET_NOISSUE_L1_CHART_FAIL } from '../../../../redux/actions/tm/dashboard';
import { HoverableDIV } from '../../../../components/HoverableTD';
import styled from 'styled-components';

const { Option } = Select;

const Description = `The overall importance indicates the entropy of this cluster 
for a particular risk indicator. The higher the value the higher the importance of the cluster`;

const GraphIndicatorContainer = styled.div`
  padding-left: 10px;
  padding-right: 20px;
  border: solid 1px #b5c2cf;
  border-radius: 20px;
  display: flex;
`;

const FilterComponent = ({
  riskIndicatorList = null,
  typologyIdChangeHandler,
  typologyListOptionsList,
  riskIndicatorLabelIndex,
  setRiskIndicatorLabelIndex,
  peerProfileGraph,
  setIsPopedOut,
  riskIndicatorIdsChangeHandler,
  typologyId
}) => {
  const [value, setValue] = useState('');
  const [filteredSuggestions, setFilteredSuggestions] = useState(null);

  useEffect(() => {
    riskIndicatorList && setFilteredSuggestions([...riskIndicatorList]);
  }, [riskIndicatorList]);

  const handleBackwardLabelChange = (index, riskIndicatorId) => {
    if (index <= 0) return;
    const currentIndex = index - 1;
    setRiskIndicatorLabelIndex(currentIndex);
    riskIndicatorIdsChangeHandler(`${riskIndicatorId},`);
  };

  const handleForwardLabelChange = (index, riskIndicatorId) => {
    if (index == riskIndicatorList?.length - 1) return;
    const currentIndex = index + 1;
    setRiskIndicatorLabelIndex(currentIndex);
    riskIndicatorIdsChangeHandler(`${riskIndicatorId},`);
  };

  const renderRiskSearchOptions = (list) => {
    if (!list) return;
    return list.map(({ riskIndicatorName, riskIndicatorId }) => ({
      label: riskIndicatorName,
      value: riskIndicatorId
    }));
  };

  const onSelect = (id) => {
    if (!Array.isArray(riskIndicatorList)) return;

    const riskIndicator = riskIndicatorList.filter(
      ({ riskIndicatorId }) => riskIndicatorId == id
    );

    riskIndicatorIdsChangeHandler(id);
    setValue(get(riskIndicator, '0.riskIndicatorName', ''));
    setFilteredSuggestions([
      { label: get(riskIndicator, '0.riskIndicatorName', ''), value: id }
    ]);

    const currentIndex = riskIndicatorList.findIndex(
      ({ riskIndicatorId }) => riskIndicatorId == id
    );
    setRiskIndicatorLabelIndex(currentIndex);
  };

  const onSearch = (label) => {
    if (!label) {
      setValue('');
      setFilteredSuggestions([...riskIndicatorList]);
      return;
    }
    setUserSearchInput(label);
    const filteredSuggestions = riskIndicatorList.filter(
      (suggestion) =>
        suggestion?.riskIndicatorName
          ?.toLowerCase()
          .indexOf(label.toLowerCase()) > -1
    );

    setFilteredSuggestions(filteredSuggestions);
  };

  const setAllIndicators = () => {
    const riskIndicatorsList = [...riskIndicatorList];
    let arrayOfRiskIndicatorIds = [];
    if (!riskIndicatorList.length) return;

    if (riskIndicatorList.length == 1) {
      riskIndicatorsList.forEach((risk) => {
        arrayOfRiskIndicatorIds.push(`${risk.riskIndicatorId},`);
      });
    } else if (riskIndicatorList.length > 1) {
      riskIndicatorsList.forEach((risk) => {
        arrayOfRiskIndicatorIds.push(risk.riskIndicatorId);
      });
    }
    const allRiskIndicators = arrayOfRiskIndicatorIds.toString();
    riskIndicatorIdsChangeHandler(allRiskIndicators);
  };

  const ImportanceToolTip = ({ text }) => {
    return (
      <div>
        <div style={{ color: 'gray' }}>Description</div>
        <br />
        {text}
      </div>
    );
  };

  const ImportanceBadge = ({ description, title }) => {
    return (
      <div className="deviation" id="pdValue">
        <HoverableDIV firstDataPoint={<ImportanceToolTip text={description} />}>
          <GraphIndicatorContainer title={title}>
            <span>
              Importance:{' '}
              <b>
                {Math.round(
                  (get(peerProfileGraph, 'data.0.importance', 0) +
                    Number.EPSILON) *
                    100
                ) / 100}
              </b>
            </span>
          </GraphIndicatorContainer>
        </HoverableDIV>
      </div>
    );
  };

  const isDataAvailable = () =>
    peerProfileGraph.data && peerProfileGraph.data.length > 0;

  return (
    <div className={style.filterContainer}>
      <div className={style.leftColumn}>
        <div className={style.selectInput}>
          {typologyListOptionsList && typologyListOptionsList.length ? (
            <Select
              style={{ width: 266 }}
              defaultValue={typologyListOptionsList?.[0]?.value}
              value={typologyId}
              onChange={typologyIdChangeHandler}>
              {typologyListOptionsList &&
                typologyListOptionsList.map((item) => {
                  return (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  );
                })}
            </Select>
          ) : (
            ''
          )}
        </div>
        {riskIndicatorList?.length ? (
          <div className={style.riskIndicator}>
            <p
              className={
                riskIndicatorLabelIndex == 0 ? `${style.disabled}` : ''
              }
              onClick={() => {
                handleBackwardLabelChange(
                  riskIndicatorLabelIndex,
                  riskIndicatorList?.[riskIndicatorLabelIndex - 1]?.[
                    'riskIndicatorId'
                  ]
                );
              }}>
              <i className={style.arrowLeft}></i>
            </p>
            <p
              className={
                riskIndicatorLabelIndex == riskIndicatorList?.length - 1
                  ? `${style.disabled}`
                  : ''
              }
              onClick={() => {
                handleForwardLabelChange(
                  riskIndicatorLabelIndex,
                  riskIndicatorList?.[riskIndicatorLabelIndex + 1]?.[
                    'riskIndicatorId'
                  ]
                );
              }}>
              <i className={style.arrowRight}></i>
            </p>
          </div>
        ) : null}
        <div className={style.riskIndicatorLabel}>
          <Tooltip
            placement="topRight"
            title={
              riskIndicatorList?.[riskIndicatorLabelIndex]?.[
                'riskIndicatorName'
              ]
            }>
            <span>
              {
                riskIndicatorList?.[riskIndicatorLabelIndex]?.[
                  'riskIndicatorName'
                ]
              }
            </span>
          </Tooltip>
        </div>
        <div className={style.importanceLabel}>
          <ImportanceBadge title="Importance" description={Description} />
        </div>
      </div>
      <div className={style.rightColumn}>
        <div className={style.riskIndicatorSearch}>
          <AutoComplete
            value={value}
            options={
              filteredSuggestions &&
              renderRiskSearchOptions(filteredSuggestions)
            }
            style={{
              width: 200
            }}
            onSelect={onSelect}
            onSearch={onSearch}
            dropdownMatchSelectWidth={500}
            allowClear={true}>
            <Input.Search
              size="small"
              placeholder="Risk indicator"
              onChange={(e) => setValue(e.target.value)}
              enterButton
            />
          </AutoComplete>
        </div>
        <div
          className={
            isDataAvailable() ? style.riskIndicatorView : style.disableViewAll
          }
          disabled={!isDataAvailable()}
          onClick={
            isDataAvailable()
              ? () => {
                  setIsPopedOut(true);
                  setAllIndicators();
                }
              : () => false
          }>
          <p>View All Risk Indicators</p>
        </div>
      </div>
    </div>
  );
};

FilterComponent.propTypes = {
  typologyList: PropTypes.array
};

export default FilterComponent;
